// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.send-text-area-part {
  margin-top: 10px;
  border: 1px solid rgba(140, 140, 140, 0.35);
  padding-right: 77px;
}
.send-text-area-part .send-text-area {
  margin-bottom: 21px;
}
.send-text-area-part .ant-col {
  position: relative;
}
.send-text-area-part .ant-col .ant-input {
  resize: none;
  width: 100%;
}
.send-text-area-part .ant-col .send-message-button {
  position: absolute;
  right: -72px;
  top: 38px;
}
.send-text-area-part .ant-col .upload-photo-button {
  position: absolute;
  right: -36px;
  top: 38px;
}
.send-text-area-part .ant-col .ant-upload-list-text-container {
  border-top: 1px solid rgba(140, 140, 140, 0.35);
}
`, "",{"version":3,"sources":["webpack://./src/components/smses/modals/mass-sms/message-text-area/styles.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,2CAAA;EACA,mBAAA;AACF;AAJA;EAMI,mBAAA;AACJ;AAPA;EAUI,kBAAA;AAAJ;AAVA;EAaM,YAAA;EACA,WAAA;AAAN;AAdA;EAkBM,kBAAA;EACA,YAAA;EACA,SAAA;AADN;AAnBA;EAwBM,kBAAA;EACA,YAAA;EACA,SAAA;AAFN;AAxBA;EA8BM,+CAAA;AAHN","sourcesContent":[".send-text-area-part {\n  margin-top: 10px;\n  border: 1px solid rgba(140, 140, 140, 0.35);\n  padding-right: 77px;\n\n  .send-text-area {\n    margin-bottom: 21px;\n  }\n\n  .ant-col {\n    position: relative;\n\n    .ant-input {\n      resize: none;\n      width: 100%;\n    }\n\n    .send-message-button {\n      position: absolute;\n      right: -72px;\n      top: 38px;\n    }\n\n    .upload-photo-button {\n      position: absolute;\n      right: -36px;\n      top: 38px;\n    }\n\n    .ant-upload-list-text-container {\n      border-top: 1px solid rgba(140, 140, 140, 0.35);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
